import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { UseSortByProps, useSortBy } from 'react-instantsearch'

import { HitsViewByType } from 'components/molecules/hits-view-by/constants'

import { useTranslate } from 'hooks'

import { fireTrackingEvent } from 'utils/tracking'

import {
  INSTANT_SEARCH_BRAND_REPLICAS_INDEX,
  INSTANT_SEARCH_INDEX,
  INSTANT_SEARCH_PRIMARY_REPLICAS_INDEX,
} from 'constants/instantSearch'

import css from './hits-sort-by.module.scss'

type HitsSortByProps = {
  viewBy: HitsViewByType
} & Omit<UseSortByProps, 'items'>

export type SortByItem = {
  value: string
  label: string
}

const HitsSortBy = ({ viewBy, ...props }: HitsSortByProps) => {
  const { t } = useTranslate('strapi-search-[...term]')
  const router = useRouter()

  useEffect(() => {
    const initSortByQuery = router.query.sortBy as string

    const initSortByIndex =
      Object.values(INSTANT_SEARCH_INDEX).find(({ query }) => initSortByQuery === query)?.name ??
      INSTANT_SEARCH_INDEX['variants-from-connector'].name

    refine(initSortByIndex)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  let items: SortByItem[] = []

  switch (viewBy) {
    case 'BRAND':
      items = Object.values(INSTANT_SEARCH_BRAND_REPLICAS_INDEX).map(({ name, label }) => ({
        label: t(label),
        value: name,
      }))
      break
    case 'PRODUCT':
    default:
      items = Object.values(INSTANT_SEARCH_PRIMARY_REPLICAS_INDEX).map(({ name, label }) => ({
        label: t(label),
        value: name,
      }))
      break
  }

  const { currentRefinement, options, refine } = useSortBy({ ...props, items })
  return (
    <div className={css.container}>
      <p>{t('PageSearch.PageSearch_sort_by')}</p>
      <select
        onChange={(event) => {
          refine(event.target.value)
          fireTrackingEvent('track', { event: 'product_sort_by', productSortByFilter: event.target.value })
        }}
        value={currentRefinement}
        className={css.sortBySelect}
        data-test-id="select-sort-by"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value} className={css.sortByOption}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}

export default HitsSortBy
